import React from "react";
import Section from "./../Section";
import SectionHeader from "./../SectionHeader";
import Features from "./../Features";
import swimmingImage from "../../images/swimming.svg";
import coffeeImage from "../../images/coffee-break.svg";
import eatingOutImage from "../../images/eating-lunch-out.svg";
import "./styles.scss";

function FeaturesSection(props) {
  return (
    <Section color={props.color} size={props.size}>
      <div className="container">
        <SectionHeader
          title={props.title}
          subtitle={props.subtitle}
          centered={true}
          size={3}
        />
        <Features
          items={[
            {
              title: "Keep the earth beautiful",
              description:
                "Reducing your waste has a positive impact of the environment around us. That means cleaner oceans and streams. It's not summer without a dip in the ocean.",
              image: swimmingImage
            },
            {
              title: "Sweet morning nectar",
              description:
                "Everyone loves coffee but we ca ndo without single use cups. They can't easily be recyclable and there's a much better alternative. Use a keep-cup instead, it cuts down on waste. A coffee a day creates 7 cups that go to landfill.",
              image: coffeeImage
            },
            {
              title: "Say no to plastic cutlery",
              description:
                "It's difficult to justify the need for single-use cutlery. If you're at home or at work, use the cutlery you have available. You don't expect to be able to cut anything with that plastic knife anyway. Do you?",
              image: eatingOutImage
            }
          ]}
        />
      </div>
    </Section>
  );
}

export default FeaturesSection;
